import { Navigate, Route, Routes, useParams } from 'react-router-dom'

import { Layout } from '@/components/layout/Layout'
import { TooltipProvider } from '@/components/ui/tooltip'
import { ToasterProvider } from '@/components/ui/use-toast'
import { AuthProvider } from '@/contexts/AuthContext'
import { CreateAd } from '@/pages/CreateAd'
import { CreateImage } from '@/pages/CreateImage'
import { Dashboard } from '@/pages/Dashboard'
import { AssetLibrary } from '@/pages/AssetLibrary'
import { Jobs } from '@/pages/Jobs'
import { JobDetail } from '@/pages/JobDetail'
import { Login } from '@/pages/Login'
import { Products } from '@/pages/Products'
import { Register } from '@/pages/Register'
import { Docs } from '@/pages/Docs'

/** Redirect /jobs/:id → /created-assets/:id preserving the param. */
function RedirectJobToCreatedAsset() {
  const { id } = useParams<{ id: string }>()
  return <Navigate to={`/created-assets/${id ?? ''}`} replace />
}

function App() {
  return (
    <AuthProvider>
      <TooltipProvider>
      <ToasterProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/create" element={<CreateAd />} />
            <Route path="/create-image" element={<CreateImage />} />
            <Route path="/products" element={<Products />} />
            {/* Renamed surfaces (per client feedback): "Asset Library" →
                "Saved Context", "Jobs" → "Created Assets". Routes follow
                the new names; old paths 301-redirect so existing bookmarks
                still work. */}
            <Route path="/saved-context" element={<AssetLibrary />} />
            <Route path="/created-assets" element={<Jobs />} />
            <Route path="/created-assets/:id" element={<JobDetail />} />
            <Route path="/docs/*" element={<Docs />} />
            {/* Legacy redirects */}
            <Route path="/assets" element={<Navigate to="/saved-context" replace />} />
            <Route path="/jobs" element={<Navigate to="/created-assets" replace />} />
            <Route path="/jobs/:id" element={<RedirectJobToCreatedAsset />} />
            <Route path="/avatars" element={<Navigate to="/create-image?tab=avatar" replace />} />
            <Route path="/composite" element={<Navigate to="/create-image?tab=composite" replace />} />
            <Route path="/generate" element={<Navigate to="/create" replace />} />
            <Route path="/scenes" element={<Navigate to="/create" replace />} />
            <Route path="/studio" element={<Navigate to="/create" replace />} />
            <Route path="/references" element={<Navigate to="/saved-context" replace />} />
            <Route path="/history" element={<Navigate to="/created-assets" replace />} />
          </Route>
        </Routes>
      </ToasterProvider>
      </TooltipProvider>
    </AuthProvider>
  )
}

export default App
